// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/CreateForm/CreateFormForm.css */

.create-form-container {
  padding: 0.5rem;
  margin:auto;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 90%;
}

.create_form_headiii {
  text-align: center;
  color: #EF6F53;
  font-size: 1.25rem;
  text-transform: uppercase;
  font-weight: 800;

}

.errorr-messagee, .successs-message {
  padding: 0.15rem;
  border-radius: 4px;
}

.errorr-messagee {
  color: #d32f2f;
  background-color: #ffebee;
  border: 1px solid #ef9a9a;
  padding: 2px;
  border-radius: 4px;
  font-size: 0.9rem;
}

.error-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
}

.error-text {
  flex: 1 1;
  line-height: 1.1;
}

.version-info {
  color: #1976d2;
  font-weight: 500;
  white-space: nowrap;
  padding: 1px;
  border-radius: 4px;
  border: 1px solid rgba(25, 118, 210, 0.2);
  min-width: fit-content;
}

.successs-message {
  color: #2e7d32;
  background-color: #e8f5e9;
  border: 1px solid #a5d6a7;
  padding: 2px;
  border-radius: 4px;
  font-size: 0.9rem;
  text-align: center;
  line-height: 1.1;
}

.create-form {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 0.5rem;
}

.company-choice-panel,
.selected-company-strip {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.6rem 0.75rem;
  margin-bottom: 0.6rem;
  border: 1px solid #d6dde7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(31, 46, 64, 0.06);
}

.company-choice-field {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
  min-width: 0;
}

.company-choice-panel label,
.selected-company-strip span {
  flex: 0 0 auto;
  min-width: 120px;
  color: #364C63;
  font-size: 0.85rem;
  font-weight: 800;
}

.company-choice-panel select {
  flex: 1 1;
  min-height: 36px;
  padding: 0.35rem 0.5rem;
  border: 1px solid #b8c2cf;
  border-radius: 8px;
  background: #ffffff;
  color: #26384d;
  font-size: 0.9rem;
  outline: none;
}

.company-choice-panel select:focus {
  border-color: #EF6F53;
  box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.14);
}

.selected-company-strip {
  justify-content: flex-start;
  background: #f8fafc;
}

.selected-company-strip strong {
  color: #EF6F53;
  font-size: 0.95rem;
  font-weight: 800;
}

.form-section {
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 0.5rem;
  flex: 1 1;
}

.form-section-title {
  color: #1976d2;
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 0.1rem;
  border-bottom: 2px solid #1976d2;
  margin-bottom: 0.5rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
  align-items: flex-start;
}

.address-field {
  flex: 2 1 !important;
}

.country-field,
.designation-field,
.disposition-field {
  flex: 1 1 !important;
}

.comment-field {
  flex: 1 1 !important;
}

.labell-input {
  flex: 1 1;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}

.labell-input label {
  flex: 0 0 auto;
  color: #333;
  font-weight: 800;
  font-size: 0.8rem;
  text-align: left;
  min-width: 120px;
}

.labell-input input,
.labell-input select {
  flex: 1 1;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
}

.required {
  color: #d32f2f;
}

.notification-checkboxes {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.35rem;
  border: 1px solid #d6dde7;
  border-radius: 8px;
  background: #ffffff;
}

.notification-checkboxes label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #364C63;
  font-size: 0.86rem;
  font-weight: 750;
  cursor: pointer;
}

.notification-checkboxes input {
  width: 16px;
  height: 16px;
  accent-color: #EF6F53;
}

.buttonn-container {
  text-align: center;
  padding: 0.25rem;
}

.submit-buttonn {
  background-color: #1976d2;
  color: white;
  padding: 0.25rem 0.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s;
}

.submit-buttonn:hover {
  background-color: #1565c0;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .create-form-container {
    padding: 0.75rem;
  }
  
  .form-section {
    padding: 0.5rem;
  }

  .company-choice-panel,
  .selected-company-strip {
    align-items: stretch;
    flex-direction: column;
    gap: 0.4rem;
  }

  .company-choice-panel label,
  .selected-company-strip span {
    min-width: 0;
  }

  .company-choice-field {
    align-items: stretch;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/CreateForm/CreateForm.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAkB;AACpB;;AAEA;;;EAGE,oBAAkB;AACpB;;AAEA;EACE,oBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":["/* src/components/routes/Forms/CreateForm/CreateFormForm.css */\n\n.create-form-container {\n  padding: 0.5rem;\n  margin:auto;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  width: 90%;\n}\n\n.create_form_headiii {\n  text-align: center;\n  color: #EF6F53;\n  font-size: 1.25rem;\n  text-transform: uppercase;\n  font-weight: 800;\n\n}\n\n.errorr-messagee, .successs-message {\n  padding: 0.15rem;\n  border-radius: 4px;\n}\n\n.errorr-messagee {\n  color: #d32f2f;\n  background-color: #ffebee;\n  border: 1px solid #ef9a9a;\n  padding: 2px;\n  border-radius: 4px;\n  font-size: 0.9rem;\n}\n\n.error-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px;\n}\n\n.error-text {\n  flex: 1;\n  line-height: 1.1;\n}\n\n.version-info {\n  color: #1976d2;\n  font-weight: 500;\n  white-space: nowrap;\n  padding: 1px;\n  border-radius: 4px;\n  border: 1px solid rgba(25, 118, 210, 0.2);\n  min-width: fit-content;\n}\n\n.successs-message {\n  color: #2e7d32;\n  background-color: #e8f5e9;\n  border: 1px solid #a5d6a7;\n  padding: 2px;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  text-align: center;\n  line-height: 1.1;\n}\n\n.create-form {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 0.5rem;\n}\n\n.company-choice-panel,\n.selected-company-strip {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.6rem 0.75rem;\n  margin-bottom: 0.6rem;\n  border: 1px solid #d6dde7;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 8px 18px rgba(31, 46, 64, 0.06);\n}\n\n.company-choice-field {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.company-choice-panel label,\n.selected-company-strip span {\n  flex: 0 0 auto;\n  min-width: 120px;\n  color: #364C63;\n  font-size: 0.85rem;\n  font-weight: 800;\n}\n\n.company-choice-panel select {\n  flex: 1;\n  min-height: 36px;\n  padding: 0.35rem 0.5rem;\n  border: 1px solid #b8c2cf;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #26384d;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.company-choice-panel select:focus {\n  border-color: #EF6F53;\n  box-shadow: 0 0 0 3px rgba(239, 111, 83, 0.14);\n}\n\n.selected-company-strip {\n  justify-content: flex-start;\n  background: #f8fafc;\n}\n\n.selected-company-strip strong {\n  color: #EF6F53;\n  font-size: 0.95rem;\n  font-weight: 800;\n}\n\n.form-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  padding: 0.5rem;\n  flex: 1;\n}\n\n.form-section-title {\n  color: #1976d2;\n  font-size: 1rem;\n  font-weight: 600;\n  padding-bottom: 0.1rem;\n  border-bottom: 2px solid #1976d2;\n  margin-bottom: 0.5rem;\n}\n\n.form-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 0.5rem;\n  align-items: flex-start;\n}\n\n.address-field {\n  flex: 2 !important;\n}\n\n.country-field,\n.designation-field,\n.disposition-field {\n  flex: 1 !important;\n}\n\n.comment-field {\n  flex: 1 !important;\n}\n\n.labell-input {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  gap: 0.5rem;\n}\n\n.labell-input label {\n  flex: 0 0 auto;\n  color: #333;\n  font-weight: 800;\n  font-size: 0.8rem;\n  text-align: left;\n  min-width: 120px;\n}\n\n.labell-input input,\n.labell-input select {\n  flex: 1;\n  padding: 0.25rem 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.8rem;\n}\n\n.required {\n  color: #d32f2f;\n}\n\n.notification-checkboxes {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 0.35rem;\n  border: 1px solid #d6dde7;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.notification-checkboxes label {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #364C63;\n  font-size: 0.86rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.notification-checkboxes input {\n  width: 16px;\n  height: 16px;\n  accent-color: #EF6F53;\n}\n\n.buttonn-container {\n  text-align: center;\n  padding: 0.25rem;\n}\n\n.submit-buttonn {\n  background-color: #1976d2;\n  color: white;\n  padding: 0.25rem 0.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: background-color 0.3s;\n}\n\n.submit-buttonn:hover {\n  background-color: #1565c0;\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .create-form-container {\n    padding: 0.75rem;\n  }\n  \n  .form-section {\n    padding: 0.5rem;\n  }\n\n  .company-choice-panel,\n  .selected-company-strip {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 0.4rem;\n  }\n\n  .company-choice-panel label,\n  .selected-company-strip span {\n    min-width: 0;\n  }\n\n  .company-choice-field {\n    align-items: stretch;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
